module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_japanese-map-d03e40207a279d3cdc131240daa4980e.svg";